module.exports = __webpack_public_path__ + "static/media/c1_4.1e94befd.png";